import { NotificationBase } from './notification-base';

export class NotificationTimesheet extends NotificationBase {
  process(): void {
    this.showAlert();
  }

  protected viewNotification(): void {
    this.navCtrl.navigateForward(`timesheet/view/${this.item.id}`);
  }
}
